import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login'
import Main from './views/Main'
import OrderSearch from './views/OrderSearch'
import OrderEdit from './views/OrderEdit'
import OrderDetail from './views/OrderDetail'
import ReportSales from './views/ReportSales'
import reportPurchase from './views/reportPurchase'
import reportInventory from './views/reportInventory'
import ReportDownload from './views/ReportDownload'
import BaseInfoEdit from './views/BaseInfoEdit'

Vue.use(Router)

export const routeQUO = 'Quotings'
export const routeOCOP = 'Ocops'
export const routeINV = 'Invoice'
export const routeCN = 'CreditNotes'
export const routePO = 'PurchaseOrders'
export const routeBCN = 'BillCreditNotes'
export const routeBL = 'Bills'
export const routeTR = 'Transfers'
export const routeAJ = 'Adjustments'
export const routeInfoPRDC = 'Products'
export const routeInfoCSR = 'Customers'
export const routeInfoSPL = 'Suppliers'
export const routeInfoWH = 'Warehouses'
export const routeInfoBRD = 'Brands'
export const routeInfoEMPL = 'Employees'

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Signin | MARVEL Admin'
      }
    },
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/quotings',
          component: OrderSearch,
          name: routeQUO,
          props: { routeName: routeQUO },
          meta: {
            title: 'Quotes | MARVEL Admin'
          }
        },
        {
          path: '/ocops',
          component: OrderSearch,
          name: routeOCOP,
          props: { routeName: routeOCOP },
          meta: {
            title: 'OCOP Prices | MARVEL Admin'
          }
        },
        {
          path: '/invoices',
          component: OrderSearch,
          name: routeINV,
          props: { routeName: routeINV },
          meta: {
            title: 'Invoices | MARVEL Admin'
          }
        },
        {
          path: '/credit_notes',
          name: routeCN,
          component: OrderSearch,
          props: { routeName: routeCN },
          meta: {
            title: 'Credit Notes | MARVEL Admin'
          }
        },
        {
          path: '/purchase_orders',
          name: routePO,
          component: OrderSearch,
          props: { routeName: routePO },
          meta: {
            title: 'Purchase Orders | MARVEL Admin'
          }
        },
        {
          path: '/bills',
          name: routeBL,
          props: { routeName: routeBL },
          component: OrderSearch,
          meta: {
            title: 'Bills | MARVEL Admin'
          }
        },
        {
          path: '/bill_credit_notes',
          name: routeBCN,
          props: { routeName: routeBCN },
          component: OrderSearch,
          meta: {
            title: 'Bill Credit Notes | MARVEL Admin'
          }
        },
        {
          path: '/transfers',
          name: routeTR,
          props: { routeName: routeTR },
          component: OrderSearch,
          meta: {
            title: 'Transfers | MARVEL Admin'
          }
        },
        {
          path: '/adjustments',
          name: routeAJ,
          props: { routeName: routeAJ },
          component: OrderSearch,
          meta: {
            title: 'Adjustments | MARVEL Admin'
          }
        },
        {
          path: '/order_add/:routeName/:operation?',
          name: 'OrderAdd',
          component: OrderEdit,
          meta: {
            title: 'Add Sheet | MARVEL Admin'
          }
        },
        {
          path: '/order_edit/:routeName/:id',
          name: 'OrderEdit',
          component: OrderEdit,
          meta: {
            title: 'Edit Sheet | MARVEL Admin'
          }
        },
        {
          path: '/order_detail/:routeName/:id',
          name: 'OrderDetail',
          component: OrderDetail,
          meta: {
            title: 'Detail Sheet | MARVEL Admin'
          }
        },
        // ------------------------report -----------------------------
        {
          path: '/sales_reports',
          component: ReportSales,
          name: ReportSales,
          meta: {
            title: 'Report Sales | MARVEL Admin'
          }
        },
        {
          path: '/purchase_reports',
          component: reportPurchase,
          meta: {
            title: 'Report Purchase | MARVEL Admin'
          }
        },
        {
          path: '/inventory_reports',
          component: reportInventory,
          meta: {
            title: 'Report Inventory | MARVEL Admin'
          }
        },
        {
          path: '/reports_download',
          component: ReportDownload,
          meta: {
            title: 'Report Download | MARVEL Admin'
          }
        },
        // ------------------------base infos--------------------------
        {
          path: '/products',
          component: OrderSearch,
          name: routeInfoPRDC,
          props: { routeName: routeInfoPRDC },
          meta: {
            title: 'Products | MARVEL Admin'
          }
        },
        {
          path: '/baseinfo/:routeName',
          name: 'BaseInfoAdd',
          component: BaseInfoEdit,
          meta: {
            title: 'Add Info | MARVEL Admin'
          }
        },
        {
          path: '/baseinfo/:routeName/:id',
          name: 'BaseInfoEdit',
          component: BaseInfoEdit,
          meta: {
            title: 'Edit Info | MARVEL Admin'
          }
        },
        {
          path: '/customers',
          component: OrderSearch,
          name: routeInfoCSR,
          props: { routeName: routeInfoCSR },
          meta: {
            title: 'Customers | MARVEL Admin'
          }
        },
        {
          path: '/suppliers',
          component: OrderSearch,
          name: routeInfoSPL,
          props: { routeName: routeInfoSPL },
          meta: {
            title: 'Suppliers | MARVEL Admin'
          }
        },
        {
          path: '/warehouses',
          component: OrderSearch,
          name: routeInfoWH,
          props: { routeName: routeInfoWH },
          meta: {
            title: 'Warehouses | MARVEL Admin'
          }
        },
        {
          path: '/brands',
          component: OrderSearch,
          name: routeInfoBRD,
          props: { routeName: routeInfoBRD },
          meta: {
            title: 'Brands | MARVEL Admin'
          }
        },
        {
          path: '/employees',
          component: OrderSearch,
          name: routeInfoEMPL,
          props: { routeName: routeInfoEMPL },
          meta: {
            title: 'Employees | MARVEL Admin'
          }
        }
      ]
    }
  ]
})
